// MATERIAL UI
import { Box, Skeleton, Grid, Divider, Typography, useMediaQuery, useTheme } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
// MUI ICONS
import LocationOnIcon from '@mui/icons-material/LocationOn'
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
// CONSTANTS
import { fontPreset } from '../../../constants/styling/fontStyleConstant';

const AuctionDetailSkeleton = () => {
    const DUMMY_LOADING = [ 0,1,2,3 ]

    const theme = useTheme()
    const downMediumScreen = useMediaQuery(theme.breakpoints.down("md"))

    const IconAndDesc = ({ icon }) => {
        return (
            <Box display='flex' gap='0 1rem' mt={1} alignItems='center'>
                <Box sx={{ padding: '.1rem 0' }}>
                    { icon }
                </Box>

                <Skeleton animation="wave" height={20} width="20%" />
            </Box>
        )
    }

    return (
        <Grid container spacing={{ xs: 2, md: 3 }}>

            <Grid item xs={12}>
                {/* MEDIUM SCREEN UI */}
                <Box display={{ xs: 'none', md: 'flex'}} gap='2rem 3rem' py={1.3} alignItems='center'>
                    <Box display='flex' flexDirection='column' flexGrow='1'>
                        <Skeleton animation="wave" height={69} width="40%" />
                        <Skeleton animation="wave" height={20} width="20%" />

                        <Box mt={2}>
                            <Grid container rowSpacing={1}>
                                <Grid item xs={12} md={6}>
                                    { IconAndDesc({ icon: <LocationOnIcon /> })  }

                                    { IconAndDesc({ icon: <TimeToLeaveIcon /> }) }

                                    { IconAndDesc({ icon: <AccessTimeIcon /> }) }
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Typography
                                        variant="body2"
                                        style={downMediumScreen ? fontPreset.body14Bold : fontPreset.body16Bold}
                                    >
                                        Memuat status lelang...
                                    </Typography>

                                    <Skeleton
                                        animation="wave"
                                        height={76}
                                        width="100%"
                                    />

                                    <Box>
                                        <LoadingButton
                                            loading
                                            variant="contained"
                                            fullWidth
                                        >
                                            Beli Token
                                        </LoadingButton>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>

                {/* SMALL SCREEN LOADING UI */}
                <Box display={{ xs: 'flex', md: 'none'}} gap='1rem' p='.5rem' alignItems='center'>
                    <Box>
                        <Skeleton animation="wave" variant="circular" height='4.8125rem' width='4.8125rem' />
                    </Box>

                    <Box display='flex' flexDirection='column' flexGrow='1'>
                        <Skeleton animation="wave" height={50} width="80%" />
                        <Skeleton animation="wave" height={15} width="50%" />
                    </Box>
                </Box>
                <Box display={{ xs: 'flex', md: 'none'}} flexDirection='column' flexGrow='1' mt={2}>
                    <Skeleton animation="wave" height={20} width="35%" />
                    <Skeleton animation="wave" height={110} width="100%" />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Divider variant='fullWidth' />
            </Grid>

            <Grid item xs={12}>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                    { DUMMY_LOADING.map((dummy) => (
                        <Grid key={`auction-detail-skeleton-${dummy + 1}`} item xs={12} sm={6} md={4} lg={3}>
                            <Skeleton variant="rectangular" animation="wave" height={280} />
                        </Grid>
                    )) }
                </Grid>
                <Divider variant='fullWidth' />
            </Grid>

        </Grid>
    )
}

export default AuctionDetailSkeleton